import ButtonWithAnalytics from "@/features/Common/components/ButtonWithAnalytics";
import IconLoader from "@/features/Common/components/IconLoader";
import SlideUpDialog from "@/features/Common/components/SlideUpDialog";
import { convertPxToRem } from "@/utils";
import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface AddToProfileModalProps {
  isModalOpen: boolean;
  onModalClose: () => void;
  onContinueButtonClick: () => void;
  onBackButtonClick: () => void;
}

export default function AddToProfileModal({
  isModalOpen,
  onModalClose,
  onContinueButtonClick,
  onBackButtonClick,
}: AddToProfileModalProps) {
  const { t } = useTranslation();

  return (
    <SlideUpDialog
      isOpen={isModalOpen}
      onClose={() => onModalClose()}
      label={t("AddToProfileModal.title")}
    >
      <Stack textAlign="center" spacing={3}>
        <IconLoader
          icon="TagWithCheckIcon"
          color="primary"
          sx={{ fontSize: convertPxToRem(90), alignSelf: "center" }}
        />

        <Stack spacing={1}>
          <Typography variant="h3" fontWeight={600}>
            {t("AddToProfileModal.title")}
          </Typography>

          <Typography variant="h4" fontWeight={400}>
            {t("AddToProfileModal.subtitle")}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={2}>
          <ButtonWithAnalytics
            intent="confirmational"
            page="AddToProfileModal"
            text={t("common.no")}
            fullWidth
            variant="outlined"
            onClick={onBackButtonClick}
          >
            {t("common.no")}
          </ButtonWithAnalytics>
          <ButtonWithAnalytics
            onClick={onContinueButtonClick}
            intent="confirmational"
            page="AddToProfileModal"
            text={t("common.yes")}
            fullWidth
          >
            {t("common.yes")}
          </ButtonWithAnalytics>
        </Stack>
      </Stack>
    </SlideUpDialog>
  );
}
